import { useTranslation } from 'react-i18next';
import InformationPopup from '../../informationPopup/informationPopup';
import { IShowDialogProps } from '../../../interface/transactionRestriction';

interface MatterRestrictionDialogsProps {
  customerIdentificationErrorDialog: IShowDialogProps;
  setCustomerIdentificationErrorDialog: (dialog: IShowDialogProps) => void;
  serviceRestrictionErrorDialog: IShowDialogProps;
  setServiceRestrictionErrorDialog: (dialog: IShowDialogProps) => void;
  onDismiss?: () => void;
}

const CLOSED_DIALOG: IShowDialogProps = { visible: false, message: '' };

const MatterRestrictionDialogs = ({
  customerIdentificationErrorDialog,
  setCustomerIdentificationErrorDialog,
  serviceRestrictionErrorDialog,
  setServiceRestrictionErrorDialog,
  onDismiss,
}: Readonly<MatterRestrictionDialogsProps>) => {
  const { t } = useTranslation();

  const renderDialog = (
    dialog: IShowDialogProps,
    setDialog: (dialog: IShowDialogProps) => void,
  ) => {
    const close = () => {
      setDialog(CLOSED_DIALOG);
      onDismiss?.();
    };
    return (
      <InformationPopup
        visible={dialog.visible}
        onConfirm={close}
        onClose={close}
        title={dialog.message ?? ''}
        subtitle={t('transaction:restrictions.youCannotEnterTransactionsForMatter')}
        cancelButtonType="default"
        cancelText={t('transaction:selectAnotherMatter')}
      />
    );
  };

  return (
    <>
      {renderDialog(customerIdentificationErrorDialog, setCustomerIdentificationErrorDialog)}
      {renderDialog(serviceRestrictionErrorDialog, setServiceRestrictionErrorDialog)}
    </>
  );
};

export default MatterRestrictionDialogs;
